var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAi = function SvgAi(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#212121",
    strokeWidth: 2,
    d: "M1 1h22v22H1z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#212121"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.708 16.886v-1.484h1.288V8.598h-1.288V7.114h4.438v1.484h-1.302v6.804h1.302v1.484zM11.756 16.886l-.784-2.492H7.5l-.77 2.492H4.854L8.13 7.114h2.295l3.249 9.772zM9.264 8.794h-.07l-1.246 4.018h2.576z"
  }))));
};
export default SvgAi;